import { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import { billingFetch, billingFetchPublic } from "./billingApi";
import "./RechargeModal.css";

const FALLBACK_PLANS = [
  { priceId: "price_1TAqNPH0QToyVJ1hyDJJIWxx", name: "starter", credits: 500, amount: 1000 },
  { priceId: "price_1TAqNaH0QToyVJ1hoPVGKT7r", name: "pro", credits: 3000, amount: 5000 },
];

export default function RechargeModal({ userId, isDarkMode, onClose }) {
  const [purchasing, setPurchasing] = useState(null);
  const [plans, setPlans] = useState(FALLBACK_PLANS);
  const [isFirstTime, setIsFirstTime] = useState(false);

  useEffect(() => {
    billingFetchPublic("/stripe/plans")
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) setPlans(data);
      })
      .catch(() => {});

    if (userId) {
      supabase
        .from("subscriptions")
        .select("id")
        .eq("user_id", userId)
        .limit(1)
        .then(({ data }) => {
          if (!data || data.length === 0) setIsFirstTime(true);
        });
    }
  }, [userId]);

  async function handlePurchase(plan) {
    setPurchasing(plan.priceId);
    try {
      const data = await billingFetch("/stripe/create-checkout", {
        method: "POST",
        body: JSON.stringify({ priceId: plan.priceId }),
      });
      if (data.url) window.location.href = data.url;
    } catch (err) {
      console.error("Checkout error:", err);
    } finally {
      setPurchasing(null);
    }
  }

  return (
    <div className="recharge-overlay" onClick={onClose}>
      <div
        className={`recharge-modal ${isDarkMode ? "dark" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="recharge-close" onClick={onClose}>
          x
        </button>
        <div className="recharge-icon-big">{isFirstTime ? "✨" : "!"}</div>
        <h3>{isFirstTime ? "Get Started with Zoomey" : "Credits Exhausted"}</h3>
        <p>
          {isFirstTime
            ? "Choose a plan to unlock your AI personal assistant and start chatting."
            : "Your AI credits have run out. Purchase a plan to continue chatting."}
        </p>

        <div className="recharge-plans">
          {plans.map((plan) => (
            <button
              key={plan.priceId}
              className={`recharge-plan-btn ${plan.name === "pro" ? "pro" : ""}`}
              onClick={() => handlePurchase(plan)}
              disabled={purchasing !== null}
            >
              <span className="rp-name">
                {plan.name.charAt(0).toUpperCase() + plan.name.slice(1)}
              </span>
              <span className="rp-price">${(plan.amount / 100).toFixed(0)}/mo</span>
              <span className="rp-credits">
                {plan.credits.toLocaleString()} credits
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
